import { Directive, ViewParent } from 'angular-ts-decorators';
import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';
import { SwChange } from '@core/app/scripts/classes/sw-change';
import { fromEvent, merge } from 'rxjs';
import { filter, takeUntil, share } from 'rxjs/operators';

/**
 * Directive that integrates any ng-model input with sw-editable-field. It adds
 * listener to 'enter' so the value committed & no other call is executed.
 *
 * # Example
 * <pre>
 *   <sw-editable-field>
 *     <input ng-model="test" sw-change-notifier sw-editable-input></any>
 *   </sw-editable-field>
 * </pre>
 */
@Directive({
  selector: '[sw-editable-input]',
  bindToController: true,
})
// TODO CORE-1301 add unit tests
export class SwEditableInputDirective extends SwChange {
  // Note! it's definitively required here; but as it's leaking to all other
  // SwChanges implementation we marked it as an optional param.
  @ViewParent('?') private ngModel: ng.INgModelController;

  constructor(
    private $element: ng.IAugmentedJQuery,
    private scopeStreams: ScopeStreams,
    private $scope,
    private $timeout: ng.ITimeoutService,
  ) {
    'ngInject';
    super();
  }

  $postLink() {
    const destroyed$ = this.scopeStreams.isDestroyed(this.$scope);

    // raw events stream
    const keydown$ = fromEvent(this.$element, 'keydown').pipe(
        takeUntil(destroyed$),
      ),
      keypress$ = fromEvent(this.$element, 'keypress').pipe(
        takeUntil(destroyed$),
      );

    const react$ = merge(keydown$, keypress$).pipe(
      filter((event: KeyboardEvent) => event.which === 13),
      share(),
    );

    // we disable other event listeners for all <enter>
    react$.subscribe((event) => {
      event.preventDefault();
      event.stopPropagation();

      this.$scope.$apply(() => {
        this.ngModel.$commitViewValue();

        this.change(this.ngModel.$modelValue);
      });
    });

    this.swEditableField.showField$
      .pipe(
        filter((value: boolean) => value),
        takeUntil(destroyed$),
      )
      .subscribe(() => {
        this.$timeout(() => {
          this.$element[0].focus();
        }, 0);
      });
  }
}
